/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter an IUPAC nucleotide motif to get its regex.`)
};

const es_iupac_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un motivo de nucleótidos IUPAC para obtener su regex.`)
};

const de_iupac_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie ein IUPAC-Nukleotidmotiv ein, um seinen Regex zu erhalten.`)
};

const nl_iupac_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een IUPAC-nucleotidemotief in om de regex te krijgen.`)
};

const fr_iupac_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un motif nucléotidique IUPAC pour obtenir sa regex.`)
};

const it_iupac_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un motivo nucleotidico IUPAC per ottenere la sua espressione regolare.`)
};

const pt_br2_iupac_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um motivo de nucleotídeos IUPAC para obter sua regex.`)
};

const pt_iupac_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um motivo de nucleótidos IUPAC para obter a sua regex.`)
};

const ja_iupac_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPACヌクレオチドモチーフを入力すると正規表現が得られます。`)
};

const zh_iupac_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入 IUPAC 核苷酸模体以获得其正则表达式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_hint_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_hint_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_hint_empty", locale)
	if (locale === "en") return en_iupac_hint_empty(inputs)
	if (locale === "es") return es_iupac_hint_empty(inputs)
	if (locale === "de") return de_iupac_hint_empty(inputs)
	if (locale === "nl") return nl_iupac_hint_empty(inputs)
	if (locale === "fr") return fr_iupac_hint_empty(inputs)
	if (locale === "it") return it_iupac_hint_empty(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_hint_empty(inputs)
	if (locale === "pt") return pt_iupac_hint_empty(inputs)
	if (locale === "ja") return ja_iupac_hint_empty(inputs)
	return zh_iupac_hint_empty(inputs)
};